module.exports = __webpack_public_path__ + "sgby/img/gp-btn.6f88e7e.png";